import { Common } from '~/models/common';
import { Benefits } from '~/models/benefits';

export const benefitsService = {
	fetch: async (): Promise<Benefits.Model[]> => {
		const params = {
			filter: {
				status: Common.Status.PUBLISHED,
			},
			fields: [
				'*',
				'seo.title',
				'seo.header',
				'seo.keywords',
				'seo.description',
				'employee.*',
				'employee.photo.*',
			],
		};

		try {
			const response = await $fetch<Benefits.Model[]>(Benefits.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch Benefits:', error);

			return [];
		}
	},
};
